export const DISCO_SITE_FROM_PUBLIC_INBOX_URL =
  'https://www.disco.ac/?utm_source=disco_playlist&utm_medium=public_inbox'

export const DISCO_SITE_SIGNUP_FROM_PUBLIC_INBOX_URL =
  'https://accounts.disco.ac/signup?utm_source=disco_playlist&utm_medium=public_inbox'

export const DISCO_SITE_FROM_BRIEF_SUBMISSION_URL =
  'https://www.disco.ac/?utm_source=disco_playlist&utm_medium=brief_submission'

export const DISCO_SITE_SIGNUP_FROM_BRIEF_SUBMISSION_URL =
  'https://accounts.disco.ac/signup?utm_source=disco_playlist&utm_medium=brief_submission'
export const MFA_SUPPORT_URL =
  'https://support.disco.ac/home/setting-up-and-using-multi-factor-authentication-mfa'

export const DISCO_CHANGELOG_URL = 'https://www.disco.ac/changelog'
